export default {
    bloodDonorStatus: null,
    bloodDonorStatusOther: null,

    plasmaBloodDonorStatus: null,
    plasmaBloodDonorStatusOther: null,

    membershipType: null,
    membershipTypeOther: null,

    associationMembershipType: null,
    associationMembershipTypeOther: null,

    firstname: null,
    lastname: null,
    phone: null,
    email: null,
    birthdate: null,
    password: null,
    employment_status: null,
    shirt_size: null,

    region: null,
    otherRegion: null,
    municipality: null,
    residence_place: null,
    address: null,

    klasa: null,
    blood_donation_id: null,
    blood_donation_count: null,
    blood_donation_stamps_count: null,
    blood_donor_in_other_country: 'no',
    blood_donor_other_country_name: null,

    member_id: null,
    rfid_number: null,

    expires_at: null,
    is_expired: true,

    already_association_member: 'no',
    already_association_member_images: [],

    images_blood_donation_ids: [],
    membership_card_image: [],
    image_for_membership_card: [],
    plasma_donor_stamps: [],
    membership_fee_image: [],
}